
import request from "./request.js"


const http = ({ url, method = 'GET', data }) => {
    if (method == "GET") {
        return request.get(url, {
            params: data
        })
    }
    if (method == "POST") {
        return request.post(url, data)
    }
    if (method == "DELETE") {
        return request.delete(url, {
            data: data
        })
    }
    if (method == "PUT") {
        return request.put(url, data)
    }
}



export default http;

/** 
 * 请求使用http
 * url          //接口
 * method       //方式
 * data         //请求参数
*/